import BlipChatImage from 'assets/img/channelsv3/blipchat.svg';
import MessengerImage from 'assets/img/channelsv3/messenger.svg';
import WorkplaceImage from 'assets/img/channelsv3/workplace.svg';
import TelegramImage from 'assets/img/channelsv3/telegram.svg';
import EmailImage from 'assets/img/channelsv3/email.svg';
import SMSImage from 'assets/img/channelsv3/sms.svg';
import InstagramImage from 'assets/img/channelsv3/instagram.svg';
import RcsImage from 'assets/img/channelsv3/rcs.svg';
import WhatsAppImage from 'assets/img/channelsv3/whatsapp.svg';
import AssistantImage from 'assets/img/channelsv3/assistant.svg';
import BusinessChatImage from 'assets/img/channelsv3/applebusinesschat.svg';
import AlexaImage from 'assets/img/channelsv3/alexa.svg';
export const CHANNELS_IMAGES = [
    { src: BlipChatImage, channel: '0mn.io' },
    { src: BlipChatImage, channel: 'BLiP Chat' },
    { src: BlipChatImage, channel: 'blipchat' },
    { src: MessengerImage, channel: 'messenger.gw.msging.net' },
    { src: MessengerImage, channel: 'Messenger' },
    { src: WorkplaceImage, channel: 'workplace.gw.msging.net' },
    { src: WorkplaceImage, channel: 'Workplace' },
    { src: TelegramImage, channel: 'telegram.gw.msging.net' },
    { src: TelegramImage, channel: 'Telegram' },
    { src: EmailImage, channel: 'mailgun.gw.msging.net' },
    { src: EmailImage, channel: 'E-mail' },
    { src: EmailImage, channel: 'mailgun' },
    { src: SMSImage, channel: 'SMS' },
    { src: InstagramImage, channel: 'instagram.gw.msging.net' },
    { src: InstagramImage, channel: 'Instagram' },
    { src: RcsImage, channel: 'googlercs.gw.msging.net' },
    { src: RcsImage, channel: 'Google RCS' },
    { src: WhatsAppImage, channel: 'wa.gw.msging.net' },
    { src: WhatsAppImage, channel: 'Whatsapp' },
    { src: WhatsAppImage, channel: 'wa' },
    { src: AssistantImage, channel: 'assistant.gw.msging.net' },
    { src: AssistantImage, channel: 'Google Assistent' },
    { src: BusinessChatImage, channel: 'businesschat.gw.msging.net' },
    { src: BusinessChatImage, channel: 'Apple Messages for Business' },
    { src: BusinessChatImage, channel: 'businesschat' },
    { src: AlexaImage, channel: 'alexa.gw.msging.net' },
    { src: AlexaImage, channel: 'Amazon Alexa' },
];
